jQuery(document).ready(function () {
  if ($(".contact").length > 0) {
    $(".contact_select").find("option:first-of-type").attr("disabled", true);
    $(".contact_select")
      .find("option:first-of-type")
      .css("font-style", "italic");

    $(".contact_expertSingle:nth-child(3n)").css("margin-right", "0");
   
    function sendMailToManager() {
      var managerMail;
      var inputToChange = $(".contact_missions");
      var selectMission = $(".wpcf7-select");
      selectMission.on("change", function () {
        var mission = this.value;
        if ( mission == 'Management de transition'){
         managerMail = 'mvincent@aravati.fr';
        } else if (mission == 'Formation Upskilling') {
         managerMail = 'mvincent@aravati.fr';
        }else if (mission = "Recrutement de dirigeants et experts digitaux"){
         managerMail = "rbegue@aravati.fr";
        }else{
         managerMail = "sredouane@aravati.fr";
        }
        inputToChange.val(managerMail);
      });
    }
    sendMailToManager();
  }
});
